import { useEffect, useState } from 'react'

export function useLoadMore<T>(itens: T[], perPage = 5) {
	const [page, setPage] = useState<number>(1)
	const [currentItens, setCurrentItens] = useState<number>(0)
	const [maxItens, setMaxItens] = useState<number | undefined>(undefined)
	const [paginatedItens, setPaginatedItens] = useState<T[]>([])

	useEffect(
		() => () => {
			setPage(1)
			setCurrentItens(0)
			setPaginatedItens([])
			setMaxItens(undefined)
		},
		[]
	)

	useEffect(() => {
		if (itens[0]) {
			setPaginatedItens(() => {
				const newState = [...itens].slice(0, page * perPage)

				setCurrentItens((current) => (current !== 0 ? current : perPage))

				return newState
			})

			setMaxItens(itens?.length)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [itens])

	useEffect(() => {
		if (page === 1) return

		setPaginatedItens((current) => {
			const newItens = [...itens].slice(currentItens, page * perPage)
			const newState = [...current, ...newItens]

			setCurrentItens(newState.length)

			return newState
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page])

	return { page, setPage, currentItens, maxItens, paginatedItens }
}
